<template>
  <div id="changelog-popup-modal">
    <Modal
      :show="shouldShowModal"
      :title="changelogData?.title || 'Update'"
      size="lg"
      theme="orange"
      :show-close-button="true"
      :close-on-escape="true"
      :body-padding="true"
      @close="handleClose"
    >
      <!-- Decorative circles -->
      <div class="changelog-decoration">
        <div class="changelog-decoration-relative">
          <div class="circle circle-large changelog-pulse changelog-pulse-delay-1"></div>
          <div class="circle circle-medium changelog-pulse changelog-pulse-delay-2"></div>
          <div class="circle circle-small changelog-pulse changelog-pulse-delay-3"></div>
        </div>
      </div>

      <!-- Changelog content -->
      <div class="changelog-content">
        <div v-if="changelogData?.body" class="changelog-prose">
          <div v-html="changelogData.body"></div>
        </div>

        <!-- Default content if no body provided -->
        <div v-else>
          Er is een nieuwe update beschikbaar voor WIZZR.
        </div>
      </div>

      <!-- Custom footer -->
     
    </Modal>
  </div>
</template>

<script setup>
defineOptions({
  name: 'ChangelogPopup',
});

import { computed, onMounted } from 'vue'
import Modal from './Modal.vue'
import { useChangelogPopup } from '@/plugins/changelogPopup.js'

const {
  showPopup,
  isClosing,
  changelogData,
  shouldShowPopup,
  closePopup,
  initializePopup
} = useChangelogPopup()

// Computed property to determine if modal should be shown
const shouldShowModal = computed(() => {
  return showPopup.value && shouldShowPopup.value
})

// Handle close button click
const handleClose = () => {
  closePopup()
}

// Initialize on component mount
onMounted(() => {
  initializePopup()
})
</script>

<style scoped>
/* Using consolidated changelog popup styles from our new CSS architecture */
/* Component-specific overrides only */
</style> 